import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/dashboard/settings')({
  beforeLoad: () => {
    throw redirect({
      to: '/manage/admin/settings',
      search: { tab: 'environmental' },
      replace: true,
    })
  },
})
